//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.4.0.0 (NJsonSchema v11.3.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class Client {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Genereert een hypotheeksamenstelling voor het gegeven voorstel.
     * @param vestigingId De identificatie van de vestiging
     * @param voorstelId De identificatie van het voorstel
     * @return Success
     */
    hypotheeksamenstelling_genereren(vestigingId: string, voorstelId: string): Promise<HypotheeksamenstellingOutput> {
        let url_ = this.baseUrl + "/Voorstellen/{voorstelId}/Hypotheekvergelijker/Hypotheeksamenstelling";
        if (voorstelId === undefined || voorstelId === null)
            throw new Error("The parameter 'voorstelId' must be defined.");
        url_ = url_.replace("{voorstelId}", encodeURIComponent("" + voorstelId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHypotheeksamenstelling_genereren(_response);
        });
    }

    protected processHypotheeksamenstelling_genereren(response: Response): Promise<HypotheeksamenstellingOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HypotheeksamenstellingOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HypotheeksamenstellingOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HypotheeksamenstellingOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HypotheeksamenstellingOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HypotheeksamenstellingOutput>(null as any);
    }

    /**
     * Voert de Hypotheekvergelijker uit met de gegeven input voor het gegeven voorstel (analyse).
    Hierbij wordt elk resultaat per hypotheeklabel afzonderlijk in een stream teruggegeven.
     * @param vestigingId De identificatie van de vestiging
     * @param voorstelId De identificatie van het voorstel
     * @param body (optional) De input voor de berekening
     * @return Success
     */
    hypotheekvergelijker_van_voorstel_uitvoeren_als_stream(vestigingId: string, voorstelId: string, body: HypotheekvergelijkerInput | null | undefined): Promise<HypotheekvergelijkerRedirectResult> {
        let url_ = this.baseUrl + "/Voorstellen/{voorstelId}/Hypotheekvergelijker/Stream";
        if (voorstelId === undefined || voorstelId === null)
            throw new Error("The parameter 'voorstelId' must be defined.");
        url_ = url_.replace("{voorstelId}", encodeURIComponent("" + voorstelId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHypotheekvergelijker_van_voorstel_uitvoeren_als_stream(_response);
        });
    }

    protected processHypotheekvergelijker_van_voorstel_uitvoeren_als_stream(response: Response): Promise<HypotheekvergelijkerRedirectResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HypotheekvergelijkerRedirectResult;
            return result200;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            let result204: any = null;
            result204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HypotheekvergelijkerRedirectResult;
            return result204;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HypotheekvergelijkerRedirectResult;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HypotheekvergelijkerRedirectResult;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HypotheekvergelijkerRedirectResult;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HypotheekvergelijkerRedirectResult>(null as any);
    }

    /**
     * Start de Hypotheekvergelijker met de gegeven input voor het gegeven voorstel (analyse).
    Er wordt een queue aangemaakt, het queue-id van deze wachtrij wordt teruggegeven.
    Het aantal te verwachten resultaten wordt bepaald en teruggegeven.
    Vervolgens wordt de hypotheekvergelijker gestart, waarvan de resultaten worden toegevoegd aan de queue.
     * @param vestigingId De identificatie van de vestiging
     * @param voorstelId De identificatie van het voorstel
     * @param body (optional) De input voor de berekening
     * @return Success
     */
    hypotheekvergelijker_van_voorstel_uitvoeren_en_toevoegen_aan_queue(vestigingId: string, voorstelId: string, body: HypotheekvergelijkerInput | null | undefined): Promise<HypotheekvergelijkerQueueResult> {
        let url_ = this.baseUrl + "/Voorstellen/{voorstelId}/Hypotheekvergelijker/Queue";
        if (voorstelId === undefined || voorstelId === null)
            throw new Error("The parameter 'voorstelId' must be defined.");
        url_ = url_.replace("{voorstelId}", encodeURIComponent("" + voorstelId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHypotheekvergelijker_van_voorstel_uitvoeren_en_toevoegen_aan_queue(_response);
        });
    }

    protected processHypotheekvergelijker_van_voorstel_uitvoeren_en_toevoegen_aan_queue(response: Response): Promise<HypotheekvergelijkerQueueResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HypotheekvergelijkerQueueResult;
            return result200;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            let result204: any = null;
            result204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HypotheekvergelijkerQueueResult;
            return result204;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HypotheekvergelijkerQueueResult;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HypotheekvergelijkerQueueResult;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HypotheekvergelijkerQueueResult;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HypotheekvergelijkerQueueResult>(null as any);
    }

    /**
     * Geeft de resultaten van een queue. De queue moet klaargezet worden via Hypotheekvergelijker/{voorstelId}/Queue.
     * @param vestigingId De identificatie van de vestiging
     * @param queueId Unieke identificatie van de queue
     * @return Success
     */
    geeft_de_resultaten_van_een_queue(vestigingId: string, queueId: string): Promise<HypotheekvergelijkerOutput> {
        let url_ = this.baseUrl + "/Hypotheekvergelijker/Hypotheekvergelijker/{queueId}";
        if (queueId === undefined || queueId === null)
            throw new Error("The parameter 'queueId' must be defined.");
        url_ = url_.replace("{queueId}", encodeURIComponent("" + queueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGeeft_de_resultaten_van_een_queue(_response);
        });
    }

    protected processGeeft_de_resultaten_van_een_queue(response: Response): Promise<HypotheekvergelijkerOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HypotheekvergelijkerOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HypotheekvergelijkerOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HypotheekvergelijkerOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HypotheekvergelijkerOutput>(null as any);
    }

    /**
     * Stopt de Hypotheekvergelijker met het gegeven queueId.
    De queue en evt. aanwezige messages worden verwijderd.
     * @param vestigingId De identificatie van de vestiging
     * @param queueId Unieke identificatie van de queue
     * @return No Content
     */
    hypotheekvergelijker_en_wachtrij_stoppen(vestigingId: string, queueId: string): Promise<void> {
        let url_ = this.baseUrl + "/Hypotheekvergelijker/Hypotheekvergelijker/{queueId}";
        if (queueId === undefined || queueId === null)
            throw new Error("The parameter 'queueId' must be defined.");
        url_ = url_.replace("{queueId}", encodeURIComponent("" + queueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHypotheekvergelijker_en_wachtrij_stoppen(_response);
        });
    }

    protected processHypotheekvergelijker_en_wachtrij_stoppen(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Geeft de resultaten van een stream. De stream moet klaargezet worden via Hypotheekvergelijker/{voorstelId}/Stream.
     * @param vestigingId De identificatie van de vestiging
     * @param streamId Unieke identificatie van de tream
     * @return Success
     */
    geeft_de_resultaten_van_een_stream(vestigingId: string, streamId: string): Promise<HypotheekvergelijkerResultaat> {
        let url_ = this.baseUrl + "/Stream/{streamId}";
        if (streamId === undefined || streamId === null)
            throw new Error("The parameter 'streamId' must be defined.");
        url_ = url_.replace("{streamId}", encodeURIComponent("" + streamId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGeeft_de_resultaten_van_een_stream(_response);
        });
    }

    protected processGeeft_de_resultaten_van_een_stream(response: Response): Promise<HypotheekvergelijkerResultaat> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HypotheekvergelijkerResultaat;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HypotheekvergelijkerResultaat;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HypotheekvergelijkerResultaat;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HypotheekvergelijkerResultaat>(null as any);
    }

    /**
     * @return Success
     */
    getVersionInfo(): Promise<VersionInfo> {
        let url_ = this.baseUrl + "/VersionInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetVersionInfo(_response);
        });
    }

    protected processGetVersionInfo(response: Response): Promise<VersionInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VersionInfo;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BadRequestResult;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VersionInfo>(null as any);
    }

    /**
     * @return Success
     */
    getFoutcodes(): Promise<{ [key: string]: string; }> {
        let url_ = this.baseUrl + "/VersionInfo/FoutCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFoutcodes(_response);
        });
    }

    protected processGetFoutcodes(response: Response): Promise<{ [key: string]: string; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: string; };
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: string; }>(null as any);
    }
}

/** AflossingsVormType Geen = 0, Annuïteit = 1, Lineair = 2, Levensverzekering = 3, Spaar = 4, Aflosvrij = 5, Krediet = 9, Belegging = 10, Hybride = 11, UnitLinked = 12, Spaarrekening = 13, AnnuïteitUitgesteld = 20, AnnuïteitBlok = 21, KredietNoPay = 22 */
export enum AflossingsVormType {
    Geen = "Geen",
    Annuïteit = "Annuïteit",
    Lineair = "Lineair",
    Levensverzekering = "Levensverzekering",
    Spaar = "Spaar",
    Aflosvrij = "Aflosvrij",
    Krediet = "Krediet",
    Belegging = "Belegging",
    Hybride = "Hybride",
    UnitLinked = "UnitLinked",
    Spaarrekening = "Spaarrekening",
    AnnuïteitUitgesteld = "AnnuïteitUitgesteld",
    AnnuïteitBlok = "AnnuïteitBlok",
    KredietNoPay = "KredietNoPay",
}

export interface BadRequestResult {
    statusCode: number;
}

export interface HypotheekRenteaftrek {
    renteaftrekId: string | null;
    volgnummer: number;
    bedrag: number | null;
    aanvangsdatum: string;
    einddatum: string;
}

/** Bevat de inhoud van een gegenereerde hypotheeksamenstelling t.b.v. de Hypotheekvergelijker. */
export interface Hypotheeksamenstelling {
    /** Lijst met gegenereerde leningdelen */
    readonly leningdelen: HypotheekvergelijkerLeningdeel[] | null;
}

/** De uitvoer van het genereren van een hypotheeksamenstelling. */
export interface HypotheeksamenstellingOutput {
    resultaat: Hypotheeksamenstelling | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Bevat de gegevens van "Contractrente". */
export interface HypotheekvergelijkerContractrente {
    /** Offerterente */
    offerterente: boolean;
    /** Dagrente */
    dagrente: boolean;
    /** Dalrente */
    dalrente: boolean;
}

/** Bevat relevante gegevens van de fiscale voortzetting van een vermogensopbouwproduct t.b.v. bankspaar-leningdelen. */
export interface HypotheekvergelijkerFiscaleVoortzetting {
    /** Ingebrachte waarde */
    ingebrachteWaardeBedrag: number | null;
}

/** Bevat de inhoud van de Hypotheekvergelijker. */
export interface HypotheekvergelijkerInput {
    /** De leningdelen van de hypotheeksamenstelling */
    leningdelen: HypotheekvergelijkerLeningdeel[];
    verklaringInkomen: HypotheekvergelijkerVerklaringInkomen | null;
    contractrente: HypotheekvergelijkerContractrente | null;
    offerte: HypotheekvergelijkerOfferte | null;
    overig: HypotheekvergelijkerOverig | null;
}

/** Gegevens van een leningdeel. */
export interface HypotheekvergelijkerLeningdeel {
    hypotheekvorm: Hypotheekvorm | null;
    /** Indicatie dat het een doorlopend leningdeel betreft */
    doorlopend: boolean;
    /** Datum aanvang van het leningdeel */
    aanvangsdatum: string | null;
    aflossingsvorm: AflossingsVormType | null;
    /** Bedrag leningdeel */
    leningdeelBedrag: number | null;
    rentevariant: RentevariantOptions;
    /** Aantal jaren rentevastperiode */
    rentevastperiodeInJaren: number | null;
    /** Aantal maanden looptijd */
    looptijdInMaanden: number | null;
    /** Deel box 1 */
    deelBox1Bedrag: number | null;
    /** Indicatie dat het een SVn Starterslening betreft */
    starterslening: boolean;
    /** Indicatie dat het een hypotheekvorm t.b.v. restschuldfinanciering betreft */
    restschuldFinanciering: boolean;
    fiscaleVoortzetting: HypotheekvergelijkerFiscaleVoortzetting | null;
    /** Lijst met renteaftrekken */
    renteaftrekken: HypotheekRenteaftrek[] | null;
}

/** Gegevens van een leningdeel. */
export interface HypotheekvergelijkerLeningdeelOutput {
    hypotheekvorm: Hypotheekvorm | null;
}

/** Bevat de gegevens van "Offerte". */
export interface HypotheekvergelijkerOfferte {
    /** Minimale offertegeldigheidsduur */
    minimaleOffertegeldigheidsduur: boolean;
    /** Geldigheidsduur minimaal */
    minimaleGeldigheidsduurInMaanden: number | null;
    /** Inclusief verlengingsduur */
    inclusiefVerlengingsduur: boolean | null;
}

/** Output voor het opvragen van de resultaten van de Hypotheekvergelijker. */
export interface HypotheekvergelijkerOutput {
    /** Lijst met de resultaten van de Hypotheekvergelijker */
    resultaten: HypotheekvergelijkerResultaat[] | null;
    status: HypotheekvergelijkerStatusOptions;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Bevat de gegevens van "Overig". */
export interface HypotheekvergelijkerOverig {
    /** Annuleringskosten offerte */
    annuleringskostenOfferte: boolean | null;
    /** Verplichte ORV boven marktwaarde % */
    verplichteOrv: boolean | null;
    /** Boete bij verkoop woning */
    boeteVerkoopWoning: boolean | null;
    /** Verhuisregeling */
    verhuisregeling: boolean | null;
}

/** Het queue-id van de wachtrij en het aantal te verwachten resultaten */
export interface HypotheekvergelijkerQueueResult {
    /** De naam (wij gebruiken een Guid) van de wachtrij / queue die gebruikt moet worden voor het ophalen van het resultaat. */
    queueId: string;
    /** Het aantal te verwachten resultaten van de hypotheekvergelijker dat aan de wachtrij / queue wordt toegevoegd. */
    aantalResultaten: number;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Het resultaat van de hypotheekvergelijker dat gebruikt wordt i.p.v. http status 302 */
export interface HypotheekvergelijkerRedirectResult {
    /** De location die gebruikt moet worden voor het ophalen van het resultaat. */
    readonly location: string | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Bevat een resultaat-item van de Hypotheekvergelijker. */
export interface HypotheekvergelijkerResultaat {
    /** Lijst met gegenereerde leningdelen */
    leningdelen: HypotheekvergelijkerLeningdeelOutput[] | null;
    /** Gets or sets code van het product zoals deze in de Adviesbox
producten-database is gedefinieerd. */
    productCode: number;
    /** Gets or sets productnaam. */
    productnaam: string | null;
    /** Gets or sets code van de maatschappij zoals deze in de Adviesbox
producten-database is gedefinieerd. */
    maatschappijCode: string | null;
    /** Gets or sets verkorte naam van de maatschappij. */
    maatschappijNaam: string | null;
    uitslagMaximaleHypotheek: UitslagOptions;
    uitslagVoorwaarden: UitslagOptions | null;
    /** De toetsrente waarmee getoetst is / hypotheekrente */
    toetsrentePercentage: number | null;
    /** De gewogen gemiddelde werkelijke rente waarmee de bruto/netto last is bepaald */
    werkelijkRentePercentage: number | null;
    /** De maximale hypotheek op inkomen */
    maximaleHypotheekBedrag: number | null;
    /** De maximale hypotheek op het onderpand */
    maximaleHypotheekOnderpandBedrag: number | null;
    /** De maximale hypotheek o.b.v. NHG voorwaarden */
    maximaleHypotheekNhgBedrag: number | null;
    /** Indicatie meer/minder lenen */
    indicatieMeerLenenBedrag: number | null;
    /** Verplichte extra aflossing */
    verplichteAflossingBedrag: number | null;
    /** De bruto maandlast bij aanvang */
    brutoMaandlastAanvangBedrag: number | null;
    /** De netto maandlast bij aanvang */
    nettoMaandlastAanvangBedrag: number | null;
    /** De totale netto last over de hele looptijd */
    nettoLastTotaalBedrag: number | null;
    /** Indicatie dat de rente daalt na de rentevastperiode automatisch bij lagere schuld-marktwaarde verhouding */
    automatischeRentedalingNaRvp: boolean;
    /** Indicatie dat de rente daalt direct bij lagere schuld-marktwaardeverhouding */
    automatischeRentedalingDirect: boolean;
    /** Bevat de regels van de toelichting m.b.t. de voorwaarden */
    voorwaardenToelichtingregels: HypotheekvergelijkerResultaatToelichting[] | null;
}

/** Bevat een toelichting van een resultaat-item van de Hypotheekvergelijker. */
export interface HypotheekvergelijkerResultaatToelichting {
    /** De toelichting */
    toelichting: string | null;
}

/** HypotheekvergelijkerStatusOptions Bezig = 1, Klaar = 2, Fout = 3 */
export enum HypotheekvergelijkerStatusOptions {
    Bezig = "Bezig",
    Klaar = "Klaar",
    Fout = "Fout",
}

/** Bevat de gegevens van "Verklaring inkomen". */
export interface HypotheekvergelijkerVerklaringInkomen {
    /** Werkgever */
    werkgever: boolean;
    /** UWV */
    uwv: boolean;
    /** Perspectief */
    perspectief: boolean;
    /** Accountantsverklaring */
    accountantsverklaring: boolean;
    /** IB stukken */
    ibStukken: boolean;
}

export interface Hypotheekvorm {
    code: number;
    omschrijving: string | null;
    aflossingsvorm: AflossingsVormType | null;
    renteboxCode: number;
    starterslening: boolean;
    restschuldFinanciering: boolean;
    heeftLooptijdInMaanden: boolean;
}

/** RentevariantOptions Rentevast = 1, Variabel = 3 */
export enum RentevariantOptions {
    Rentevast = "Rentevast",
    Variabel = "Variabel",
}

/** UitslagOptions Wit = 0, Groen = 1, Oranje = 2, Rood = 3 */
export enum UitslagOptions {
    Wit = "Wit",
    Groen = "Groen",
    Oranje = "Oranje",
    Rood = "Rood",
}

export interface ValidationResultModel {
    code: string | null;
    target: string | null;
    message: string | null;
}

export interface ValidationResultsModel {
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

export interface VersionInfo {
    naam: string | null;
    versie: string | null;
    auteur: string | null;
    copyright: string | null;
    opstartDatumTijd: string | null;
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}